import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { ToneDto, ToneDtoImpl } from '../tonedto';

export class PreviewToneBuilder
 {
    constructor(private previewToneResponse: any)
     {
        if(previewToneResponse === undefined)
        {
            throw new NoDataException("Preview tone data doesnt exists");
        }
    }

    buildAll(): ToneDto
    {
        return this.parsePreviewToneResponse();
    }

    private parsePreviewToneResponse(): ToneDto
    {
        let toneDto = new ToneDtoImpl();

        toneDto.setId(this.previewToneResponse.tone);
        toneDto.setToneName(this.previewToneResponse.toneName);
        toneDto.setImgPath(this.previewToneResponse.toneIdpreviewImageUrl);
        toneDto.setToneUrl(this.previewToneResponse.toneIdStreamingUrl);
        toneDto.setArtistName(this.previewToneResponse.artistName);
        toneDto.setAlbumName(this.previewToneResponse.album);
        toneDto.setCategoryId(this.previewToneResponse.categoryId);
        toneDto.setLikeCount(this.previewToneResponse.likeCount);
       
        return toneDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/previewtone/previewtonebuilder.tsx